/**
 * 금요성령집회 설교 페이지
 */

import React from 'react';
import { SermonList } from '../components/SermonList';

export const FridaySermon: React.FC = () => {
  return <SermonList sermonType="friday" title="금요성령집회" />;
};
